import { generateEntityKey } from "@src/presentation/pages/Organizations/utils/addEditFormUtils";

export const DEDUCTION_CATEGORY_KEY_ALREADY_EXISTS_MESSAGE =
  "This Category Key already exists.";

const DEDUCTION_CATEGORY_KEY_CHARS = /[^A-Z-]/g;
const DEDUCTION_CATEGORY_KEY_MAX_LENGTH = 255;
const DEDUCTION_CATEGORY_KEY_PATTERN = /^[A-Z]+(-[A-Z]+)*$/;
const DEDUCTION_CATEGORY_KEY_FORMAT_MESSAGE =
  "Only uppercase letters and hyphens are allowed";

function getMutationErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message.trim() : "";
}

export function isDeductionCategoryKeyDuplicateError(error: unknown): boolean {
  const normalized = getMutationErrorMessage(error).toLowerCase();
  return (
    normalized.includes("category key") ||
    normalized.includes("duplicate") ||
    normalized.includes("already exists")
  );
}

export function generateDeductionCategoryKeyFromName(name: string): string {
  return generateEntityKey(
    name,
    DEDUCTION_CATEGORY_KEY_CHARS,
    DEDUCTION_CATEGORY_KEY_MAX_LENGTH,
  );
}

export function createDeductionCategoryKeyRules() {
  return [
    { required: true, message: "Category key is required" },
    {
      pattern: DEDUCTION_CATEGORY_KEY_PATTERN,
      message: DEDUCTION_CATEGORY_KEY_FORMAT_MESSAGE,
    },
    {
      max: DEDUCTION_CATEGORY_KEY_MAX_LENGTH,
      message: `Category key must be less than or equal to ${DEDUCTION_CATEGORY_KEY_MAX_LENGTH} characters.`,
    },
  ];
}
